/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
import React from 'react';
import request from "superagent";
import API from "../../config/API";
import Job from "./Job";
import CheckboxFilter from './CheckboxFilter';
import LocationFilter from './LocationFilter';
import './Jobs.scss';
import JobsBase from "./JobsBase";
import {accentFold, stripTags} from "../../helpers/filters";

// eslint-disable-next-line react/prefer-stateless-function
class Jobs extends JobsBase {

    state = {
        textFilter: '',
        locationFilter: [],
        functionFilter: [],
        jobTypeFilter: [],
        jobsLoaded: false,
        jobs: {},
        jobPostsLoaded: false,
        jobPosts: {},
        officesLoaded: false,
        offices: {},
        page: 1,
        windowWidth: window.innerWidth,
        hideSideBar: false
    }

    componentDidMount() {
        super.componentDidMount();

        request.get(`${API.getHost()}/harvest.php?path=/job_posts/`).then(res => {
            if (res && res.body) {
                this.setState({jobPosts: res.body, jobPostsLoaded: true});
            }
        });

        this.getStateFromParams();
        this.loadShortcodeProps();

        window.addEventListener('resize', this.handleResize);
    }

    loadShortcodeProps = () => {
        if(this.props.location && this.props.location.length) {
            this.setState({locationFilter: [this.props.location], hideSideBar: true});
        }

        if(this.props.category && this.props.category.length) {
            this.setState({functionFilter: [this.props.category], hideSideBar: true});
        }

        if(this.props.jobType && this.props.jobType.length) {
            this.setState({jobTypeFilter: [this.props.jobType], hideSideBar: true});
        }
    }

    getStateFromParams = () => {
        if (!window.location.search) return;

        // Only allow specific state items to be set via queryparams
        const allowedOverrides = [
            'textFilter',
            'locationFilter',
            'jobTypeFilter',
            'functionFilter'
        ];

        // Merge Params back into an Object
        const params = decodeURI(window.location.search)
            .replace('?', '')
            .split('&')
            .map(param => param.split('='))
            .filter(([key, value]) => allowedOverrides.includes(key.replace('[]', '')))
            .reduce((values, [key, value]) => {
                if (key.includes('[]')) {
                    const arrayKey = key.replace('[]', '');
                    // eslint-disable-next-line no-param-reassign
                    if (!values[arrayKey]) values[arrayKey] = [];
                    // eslint-disable-next-line no-param-reassign
                    values[arrayKey] = [value, ...values[arrayKey]]
                    return values;
                }
                // eslint-disable-next-line no-param-reassign
                values[key] = value;
                return values;
            }, {});

        this.setState(params);
    };

    /**
     * Filter jobs by title
     *
     * @param job
     * @return {boolean}
     */
    filterTitle = job => {
        if (!this.state.textFilter) return true;
        if (!job.name) return false;

        return stripTags(accentFold(job.jobPost.title)).replace(/\W/g, '').toLowerCase().includes(accentFold(this.state.textFilter).replace(/\W/g, '').toLowerCase()) 
            || stripTags(accentFold(job.custom_fields.business_line)).replace(/\W/g, '').toLowerCase().includes(accentFold(this.state.textFilter).replace(/\W/g, '').toLowerCase())
            || stripTags(accentFold(job.jobPost.location.name)).replace(/\W/g, '').toLowerCase().includes(accentFold(this.state.textFilter).replace(/\W/g, '').toLowerCase());
    };

    /**
     * Filter jobs by job_posts live status
     * @param job
     */
    filterLiveJobs = job => {
        if (!(this.state.jobPosts && this.state.jobPosts).length) return false;

        return !!job.jobPost.live;
    };

    /**
     * Filter jobs by job_posts external status
     * @param job
     */
    filterExternalJobs = job => {
        if (!(this.state.jobPosts && this.state.jobPosts).length) return false;

        return !!job.jobPost.external && !job.jobPost.internal;
    };

    /**
     * Filter jobs by office location
     *
     * @param job
     * @return {boolean}
     */
    filterLocation = job => {
        if (!this.state.locationFilter || !this.state.locationFilter.length) return true;
        if (!job.jobPost || !job.jobPost.location.name) return false;

        for(let i = 0; i < this.state.locationFilter.length; i++) {
            if(job.jobPost.location.name.includes(this.state.locationFilter[i].split(',')[0]) || 
                this.state.locationFilter[i].includes(job.jobPost.location.name)) {
                return true;
            }
        }

        return false;
    }

    /**
     * Filter jobs by function
     *
     * @param job
     * @return {boolean}
     */
    filterFunction = job => {
        if (!this.state.functionFilter || !this.state.functionFilter.length) return true;
        if (!(job.custom_fields && job.custom_fields.business_line)) return false;

        const functionFilter = this.state.functionFilter;
        if (document.location.href.indexOf("teams/technology") > 0) {
            if ((functionFilter.includes('Technology')) && (!functionFilter.includes('Technology Other'))) {
                functionFilter.push('Technology Other');
            }
        }
        
        return functionFilter.includes(job.custom_fields.business_line);
    }

    /**
     * Filter jobs by role
     *
     * @param job
     * @return {boolean}
     */
    filterJobType = job => {
        if (!this.state.jobTypeFilter || !this.state.jobTypeFilter.length) return true;
        if (!(job.custom_fields && job.custom_fields.job_level)) return false;
        return this.state.jobTypeFilter.includes(job.custom_fields.job_level);
    }

    filterTemplates = job => !job.is_template;

    toggleMobileFilters = () => {
        const filters = document.getElementById('jobFilters');
        if (!filters) {
            return;
        }
        if(filters.className.includes('closed')) {
            filters.className = 'filters mobileFilters open';
        } else {
            filters.className = 'filters mobileFilters closed';
        }
    }

    handleResize = () => {
        const filters = document.getElementById('jobFilters');
        this.setState({windowWidth: window.innerWidth});

        if(window.innerWidth > 768) {
            filters.className = 'filters';
        } else {
            filters.className = 'filters mobileFilters closed';
        }
    }

    mergeJobsAndJobPosts = () => {
        const jobs = [];
        if(this.state.jobPosts && this.state.jobPosts.length) {
            this.state.jobPosts.forEach(jobPost => {
                if(this.state.jobs && Object.keys(this.state.jobs).length) {
                    this.state.jobs.forEach(job => {
                        if(job.id === jobPost.job_id) {
                            jobs.push({...job, jobPost});
                        }
                    });
                }
            });
        }

        return jobs;
    }

    render() {
        const {jobTypes, functions, offices} = this.getOfficesRolesAndFunctions();

        // Apply currently active filters if there are jobs.
        const filteredJobs = this.state.jobs && Object.keys(this.state.jobs).length && this.state.jobPosts && Object.keys(this.state.jobPosts).length ?
            this.mergeJobsAndJobPosts()
                .filter(this.filterLiveJobs)
                .filter(this.filterExternalJobs)
                .filter(this.filterTitle)
                .filter(this.filterTemplates)
                .filter(this.filterLocation)
                .filter(this.filterFunction)
                .filter(this.filterJobType) : {};
                
        // Determine pagination start and end indexes
        const numPages = Math.ceil(filteredJobs.length / 10);
        const startIndex = this.state.page !== 1 ? ((this.state.page - 1) * 10 + 1) : 1;
        const endIndex = this.state.page === numPages ? filteredJobs.length : this.state.page * 10;

        // Prevent Pagination Overshoot
        if (this.state.page > numPages && numPages !== 0) this.setState({page: numPages});

        return (
            <div className="jobsContainer">

                {this.state.hideSideBar ? null : (
                    <div className={`filters${this.state.windowWidth <= 768 ? ' mobileFilters closed' : ''}`} id="jobFilters">
                        {this.state.windowWidth > 768 ? (
                            <h3>Refine job results</h3>
                        ) : (
                            <button className="sideBar__search--mobileButton" onClick={this.toggleMobileFilters}><h3>Refine job results</h3><span className="fas fa-chevron-down"/></button>
                        )}

                        <div className="sideBar__search sideBar__search--onInput">
                            <div className="sideBar__search--inputContainer">
                                <input placeholder="Search" className="sideBar__search--input" type="text" value={this.state.textFilter} onChange={e => this.handleChange(e, 'textFilter')}/>
                            </div>

                            <LocationFilter options={offices} selected={this.state.locationFilter} type="location" handleChange={this.handleFilterChange}/>
                            <CheckboxFilter options={functions} selected={this.state.functionFilter} type="function" name="Function" handleChange={this.handleFilterChange}/>
                            <CheckboxFilter options={jobTypes} selected={this.state.jobTypeFilter} type="jobType" name="Job Type" handleChange={this.handleFilterChange}/>

                            <button onClick={this.clearFilters} className="button button--ghost sideBar__search--clearFilters">Clear Filters</button>
                        </div>
                    </div>
                )}

                <div className={`jobs${this.state.hideSideBar ? ' jobs--fullWidth' : ''}`}>
                    {filteredJobs && Object.keys(filteredJobs).length ? (
                        <div>
                            <h4>Job openings {startIndex} - {endIndex} of {filteredJobs.length}</h4>
                            <div className="jobsList">
                                {filteredJobs.slice(startIndex - 1, endIndex).map(job => (
                                    <Job job={job} job_post={job.jobPost}/>
                                ))}
                            </div>

                            <div className="jobsPagination">
                                <div className="jobsPagination--buttons">
                                    <button className="button button--ghost" disabled={this.state.page === 1} onClick={() => this.setState({page: this.state.page - 1})}><span className="far fa-arrow-left" aria-hidden="true"/></button>
                                    <button className="button button--ghost" disabled={this.state.page === numPages} onClick={() => this.setState({page: this.state.page + 1})}><span className="far fa-arrow-right" aria-hidden="true"/></button>
                                </div>

                                <span>Page {this.state.page} of {numPages}</span>
                            </div>
                        </div>
                    ) : null}

                    {this.state.jobsLoaded && this.state.jobPostsLoaded && (!filteredJobs || !Object.keys(filteredJobs).length) ? (
                        <div>No Results</div>
                    ) : null}
                </div>

            </div>
        );
    }
}

export default Jobs;



// WEBPACK FOOTER //
// ./frontend/components/Jobs/Jobs.jsx